export enum ICS2InformationExchangeMessages {
    IE3Q01 = 'IE3Q01', // Do Not Load (DNL)
    IE3Q02 = 'IE3Q02', // Additional Info Request
    IE3Q03 = 'IE3Q03', // HRCM (High risk cargo & mail) Screening Request
    IE3Q05 = 'IE3Q05', // Consult ENS Request (sent by us)
    IE3N06 = 'IE3N06', // Arrival notification request
    IE3R08 = 'IE3R08', // ENS Consultation Results (the response to our IE3Q05)
    IE3N01 = 'IE3N01', // ENS lifecycle validation error notification
    IE3N99 = 'IE3N99', // Error notification
}
